import type { PastePreviewResponse } from '../../../shared/api';
import { esc, money, shortDate } from '../format';

/** The "Paste an alert" sheet (test mode). Same sheet patterns as Add spending. */
export function vPasteSheet(preview: PastePreviewResponse | null): string {
  if (!preview) {
    return `<div class="grab"></div><h2>Paste an alert</h2>
  <label class="fld"><span>Card alert email</span><textarea id="p-text" rows="8" placeholder="Paste the whole alert email here"></textarea></label>
  <p class="hint">Email addresses are removed before Hush reads it. The text itself is never saved.</p>
  <p class="err" id="f-err"></p>
  <div class="btns"><button class="btn primary" data-a="paste-read">Read it</button></div>`;
  }
  const r = preview.read;
  const row = (label: string, value: string) => `<div><span>${label}</span><span>${value}</span></div>`;
  return `<div class="grab"></div><h2>Here is what Hush read</h2>
  <div class="upc">
    ${row('Merchant', r.merchant ? esc(r.merchant) : 'Not in the alert')}
    ${r.bankText && r.bankText !== r.merchant ? row('Bank text', esc(r.bankText)) : ''}
    ${row('Amount', money(r.amountCents, 2))}
    ${row('Card', r.cardLast4 ? `ending ${esc(r.cardLast4)}` : 'Not in the alert')}
    ${row('Date', r.date ? shortDate(r.date) : 'Not in the alert, so today')}
  </div>
  ${r.merchant ? '' : '<p class="hint">With no merchant, it is added as "Unknown merchant" and waits in Review for you.</p>'}
  ${r.confidence < 0.7 ? '<p class="hint">Hush is not sure about this one, so it will wait in Review.</p>' : ''}
  <p class="err" id="f-err"></p>
  <div class="btns"><button class="btn primary" data-a="paste-add">Add to budget</button><button class="btn" data-a="paste-open">Start over</button></div>`;
}
